'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "onChange", "trimInputValue", "validateDefaultValue"];
import { cloneElement, Children, Component } from 'react';
const trimValue = evt => {
  if (typeof evt.target.value === 'string') {
    evt.target.value = evt.target.value.trim();
  }
};
export default class WrappedChildInput extends Component {
  constructor(...args) {
    super(...args);
    this.handleChange = evt => {
      const {
        onChange,
        children,
        trimInputValue
      } = this.props;
      const child = Children.only(children);
      if (trimInputValue) {
        trimValue(evt);
      }
      onChange(evt);
      if (child.props.onChange) {
        child.props.onChange(evt);
      }
    };
  }
  componentDidMount() {
    const {
      onChange,
      validateDefaultValue,
      trimInputValue,
      children
    } = this.props;
    if (validateDefaultValue) {
      const child = Children.only(children);
      const defaultValue = child.props.value || child.props.defaultValue || '';
      const evt = {
        target: {
          value: defaultValue
        }
      };
      if (trimInputValue) {
        trimValue(evt);
      }
      onChange(evt);
    }
  }
  render() {
    const _this$props = this.props,
      {
        children
      } = _this$props,
      rest = _objectWithoutPropertiesLoose(_this$props, _excluded);
    const child = Children.only(children);
    return /*#__PURE__*/cloneElement(child, Object.assign({}, rest, child.props, {
      onChange: this.handleChange
    }));
  }
}

/**
 * @typedef {Object} WrappedChildInputProps
 * @property {React.ReactNode} children
 * @property {function} onChange
 * @property {boolean} trimInputValue
 * @property {boolean} [validateDefaultValue]
 */
WrappedChildInput.defaultProps = {
  trimInputValue: false
};